module.exports = __webpack_public_path__ + "assets/img/01b.69c9f6f0.jpg";